import React, { Component } from 'react';
import { connect } from 'react-redux';
import { trackMixpanelPageView } from 'helpers/post';
import TrackingService from 'services/TrackingService';
import { Button } from 'reactstrap';
import './OrganizationType.scss';
import { get } from 'lodash';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import BasicOptionCard from '../OptionCards/BasicOptionCard';
import { Link } from 'react-router-dom';
import { ORGANIZATION_TYPE_OPTIONS_V3 } from '@helpers/enums';
import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import { getFunnelStepperConfig } from '../funnelSteps';

class OrganizationType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOrgType: null,
      selectedOrgTitle: null,
    };
    this.trackingService = new TrackingService();
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account/organization-type');

    // Query params are automatically captured by withQueryParamCapture HOC
    // Check if orgType exists in localStorage (set by hook or previous selection)
    const storedOrgType = localStorage.getItem('registrationOrgType');

    if (storedOrgType) {
      const orgOption = ORGANIZATION_TYPE_OPTIONS_V3.find(option => option.value === storedOrgType);
      if (orgOption) {
        // Update state to show selection in UI
        this.setState({
          selectedOrgType: storedOrgType,
          selectedOrgTitle: orgOption.title,
        });

        // If orgType came from URL parameter, auto-route to sign-up
        const searchParams = get(this.props, 'location.search', '');
        if (searchParams) {
          const params = new URLSearchParams(searchParams);
          const urlOrgType = params.get('orgType');
          if (urlOrgType === storedOrgType) {
            // Auto-route to sign-up since orgType was in URL
            this.props.history.push('/create-account/organization-details');
          }
        }
      }
    }
  }

  onSelect = (orgType, title) => e => {
    e.preventDefault();
    e.currentTarget.blur();
    this.setState({
      selectedOrgType: orgType,
      selectedOrgTitle: title,
    });
    trackMixpanelPageView('/organization_type_selected', {
      organization_type: orgType,
      organization_title: title,
      page: '/create-account/organization-type',
    });
  };

  onContinue = () => {
    const { selectedOrgType } = this.state;
    localStorage.setItem('registrationOrgType', selectedOrgType);
    if (selectedOrgType) {
      this.props.history.push('/create-account/organization-details');
    }
  };

  onBack = () => {
    this.props.history.push('/create-account/role');
  };

  renderOptionCard = ({ title, value, isSelected }) => (
    <BasicOptionCard
      title={title}
      onClick={this.onSelect(value, title)}
      selected={isSelected}
      padding="md"
      fontSize="18px"
    />
  );

  onClickLookingForWork = () => {
    this.props.history.push('athletic-trainer-sign-up');
  };

  trackLogin = () => {
    trackMixpanelPageView('IntroLogInClick');
  };

  render() {
    const { selectedOrgType } = this.state;
    const buttonDisabled = !selectedOrgType;
    const funnelStepper = getFunnelStepperConfig('/create-account/organization-type');

    return (
      <div className="organization-type">
        <main>
          {funnelStepper && (
            <div className="next-steps-mobile-stepper">
              <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
            </div>
          )}
          <header>
            <div className="screen-title">Pick your organization type</div>
          </header>
          <div className="content">
            <div className="organization-options">
              {ORGANIZATION_TYPE_OPTIONS_V3.map(({ title, value }) =>
                this.renderOptionCard({
                  title,
                  value,
                  isSelected: selectedOrgType === value,
                })
              )}
            </div>
            <div className="athletic-trainer-link" onClick={this.onClickLookingForWork}>
              <p>I'm an athletic trainer looking for work</p>
              <i className="fas fa-arrow-right"></i>
            </div>
          </div>
        </main>
        <div className="navigation-buttons">
          <div className="nav-login-container">
            <div className="nav-login-text">Already have an account?</div>
            <Link to="/" onClick={this.trackLogin} className="login-btn gotham-medium-font">
              <div>Log In</div>
            </Link>
          </div>
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue</div>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser,
});

// Wrap with HOC to automatically capture query parameters
export default withQueryParamCapture(connect(mapStateToProps)(OrganizationType));
